/**
 * 3-Step Vinyl Constructor V2 (Art Vinyl Disc).
 * Steps: 1 = Cover upload, 2 = Cover text, 3 = Add-ons.
 * Clone of Constructor 1 for Art Vinyl Disc. Scoped to [data-vinyl-mode="3step-v4"].
 *
 * Ported from the main 7-step constructor: upload flow, crop modal,
 * cover text overlay (draggable/resizable on preview), color pickers,
 * format toolbars, font previews.
 */
(function() {
  'use strict';

  var root = document.querySelector('[data-vinyl-mode="3step-v4"]');
  if (!root) return;

  var config = window.vinylConfig3stepV4 || {};
  var FILESTACK_API_KEY = config.filestackApiKey || '';
  var _isShopifyPayments = (config.currencyType === '1' || config.currencyType === 1);
  var _shopCurrency = config.shopCurrency || 'USD';
  var _cartCurrency = config.cartCurrency || _shopCurrency;
  var _isMultiCurrency = (_cartCurrency !== _shopCurrency);
  var ID_SUFFIX = '_3step_v4';
  var COVER_KEYS = ['A', 'A2', 'A3', 'B', 'B2', 'B3', 'B4'];
  var FRONT_KEYS = ['A', 'A2', 'A3'];
  var BACK_KEYS  = ['B', 'B2', 'B3', 'B4'];
  var STORAGE_KEY = 'vinyl_3step_v4_state_' + (config.sectionId || '');

  var state = {
    currentStep: 1,
    uploadedFiles: {},
    coverText: {
      A:  { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 15, w: 50 },
      A2: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 45, w: 50 },
      A3: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 75, w: 50 },
      B:  { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 35, w: 50 },
      B2: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 53, w: 50 },
      B3: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 70, w: 50 },
      B4: { text: '', font: 'Roboto', size: '24', lineHeight: '1.2', color: '#804040', position: 'center', bold: false, italic: false, underline: false, x: 50, y: 85, w: 50 }
    },
    addonsTotal: 0,
    basePrice: config.basePrice || 0,
    discountRatio: config.discountRatio || 0.28,
    quantity: 1,
    customizationComplete: false,
    cropper: null,
    cropTargetIndex: null,
    cropSourceMime: null,
    cropSourceName: null
  };

  function sid(elId) { return document.getElementById(elId + ID_SUFFIX) || document.getElementById(elId); }
  function q(sel) { return root.querySelector(sel); }
  function qAll(sel) { return root.querySelectorAll(sel); }

  var dom = {
    accordion: q('.vinyl-accordion'),
    form: q('form'),
    submitBtn: q('[type="submit"]'),
    shopPayBtn: q('.vinyl-btn--shop-pay'),
    quantityInput: document.getElementById('vinyl-quantity-input-3step-v4'),
    cropModal: document.getElementById('vinylCropModal'),
    cropImage: document.getElementById('vinyl-crop-image'),
    cropConfirm: document.getElementById('vinyl-crop-confirm'),
    cropCancel: document.getElementById('vinyl-crop-cancel'),
    previewThumbs: root.querySelectorAll('.vinyl-preview__thumb'),
    previewSlides: root.querySelectorAll('.vinyl-preview__slide')
  };

  /* ==========================================================================
     HIDE SIDE A / SIDE B THUMBS — keep FRONT, BACK, ALL
     ========================================================================== */
  (function hideExtraThumbs() {
    root.querySelectorAll('.vinyl-preview__thumb').forEach(function(thumb) {
      var target = thumb.dataset.target;
      if (target === 'vinyl-a' || target === 'vinyl-b') thumb.style.display = 'none';
    });
    root.querySelectorAll('.vinyl-preview__slide').forEach(function(slide) {
      var ds = slide.dataset.slide;
      if (ds === 'vinyl-a' || ds === 'vinyl-b') slide.style.display = 'none';
    });
  })();

  /* ==========================================================================
     PREVIEW SLIDE NAVIGATION
     ========================================================================== */
  function activatePreviewSlide(slideId) {
    dom.previewThumbs.forEach(function(t) { t.classList.remove('vinyl-preview__thumb--active'); });
    dom.previewSlides.forEach(function(s) { s.classList.remove('vinyl-preview__slide--active'); });
    var preview = root.querySelector('.vinyl-preview__slides');
    if (preview) {
      preview.classList.remove('vinyl-preview__slides--hero');
      preview.classList.toggle('vinyl-preview__slides--fullset', slideId === 'full-set');
    }
    var slide = root.querySelector('.vinyl-preview__slide[data-slide="' + slideId + '"]');
    var thumb = root.querySelector('.vinyl-preview__thumb[data-target="' + slideId + '"]');
    if (slide) slide.classList.add('vinyl-preview__slide--active');
    if (thumb) thumb.classList.add('vinyl-preview__thumb--active');
    if (slideId === 'full-set') refreshFullSetTextOverlays();
  }

  function refreshFullSetTextOverlays() {
    COVER_KEYS.forEach(function(key) { updateCoverTextPreview(key); });
  }

  function bindPreviewThumbs() {
    dom.previewThumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var target = thumb.dataset.target;
        if (target) activatePreviewSlide(target);
      });
    });
  }

  /* ==========================================================================
     STATE PERSISTENCE
     ========================================================================== */
  function saveState() {
    try {
      var snap = { coverText: state.coverText, quantity: state.quantity, uploadedFiles: {} };
      [1, 2].forEach(function(i) {
        var f = state.uploadedFiles[i];
        if (f) snap.uploadedFiles[i] = { name: f.name, resolution: f.resolution, fileUrl: f.fileUrl || f.previewUrl, previewUrl: f.previewUrl || f.fileUrl };
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
    } catch (e) {}
  }

  function restoreState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var snap = JSON.parse(raw);
      if (snap.coverText) {
        COVER_KEYS.forEach(function(k) {
          if (snap.coverText[k]) state.coverText[k] = Object.assign({}, state.coverText[k], snap.coverText[k]);
        });
      }
      if (snap.quantity) state.quantity = snap.quantity;
      if (dom.quantityInput) dom.quantityInput.value = state.quantity;
      if (snap.uploadedFiles) {
        Object.keys(snap.uploadedFiles).forEach(function(k) {
          var f = snap.uploadedFiles[k];
          if (f && f.previewUrl) showUploadedFile(parseInt(k, 10), f.name || 'image', f.resolution || '', f.previewUrl, f.fileUrl || f.previewUrl, 0, 0);
        });
      }
      COVER_KEYS.forEach(function(k) {
        var d = state.coverText[k]; if (!d) return;
        var ti = sid('coverText' + k);
        var fs = sid('coverFont' + k);
        var ss = sid('coverSize' + k);
        var lh = sid('coverLineHeight' + k);
        var wr = sid('coverWidth' + k);
        var wv = sid('coverWidthVal' + k);
        if (ti) ti.value = d.text || '';
        if (fs) fs.value = d.font || 'Roboto';
        if (ss) ss.value = d.size || '24';
        if (lh) lh.value = d.lineHeight || '1.2';
        if (wr) wr.value = d.w || 50;
        if (wv) wv.textContent = (d.w || 50) + '%';
        if (d.text) updateCoverTextPreview(k);
      });
      return true;
    } catch (e) { return false; }
  }

  /* ==========================================================================
     CUSTOMIZATION STATUS
     ========================================================================== */
  function checkCustomizationStatus() {
    state.customizationComplete = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
    if (dom.submitBtn) {
      dom.submitBtn.disabled = !state.customizationComplete;
      dom.submitBtn.classList.toggle('vinyl-btn--customization', !state.customizationComplete);
    }
    if (dom.shopPayBtn) {
      dom.shopPayBtn.disabled = !state.customizationComplete;
      dom.shopPayBtn.classList.toggle('vinyl-btn--customization', !state.customizationComplete);
    }
    updateAddonsTotal();
    updateStepCheckmarks();
    saveState();
  }

  function updateStepCheckmarks() {
    var step1El = root.querySelector('[data-step="1"]');
    var step2El = root.querySelector('[data-step="2"]');
    var step3El = root.querySelector('[data-step="3"]');

    var step1Done = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
    var step2Done = !!(state.coverText.A.text || state.coverText.A2.text || state.coverText.A3.text ||
                       state.coverText.B.text || state.coverText.B2.text || state.coverText.B3.text || state.coverText.B4.text);
    var step3Done = !!root.querySelector('.vinyl-addon input[type="checkbox"]:checked');

    if (step1El) step1El.classList.toggle('vinyl-step--checked', step1Done);
    if (step2El) step2El.classList.toggle('vinyl-step--checked', step2Done);
    if (step3El) step3El.classList.toggle('vinyl-step--checked', step3Done);

    var thumb1 = root.querySelector('.vinyl-preview__thumb[data-upload-index="1"]');
    var thumb2 = root.querySelector('.vinyl-preview__thumb[data-upload-index="2"]');
    if (thumb1) { var c1 = thumb1.querySelector('.vinyl-preview__thumb-check'); if (c1) c1.style.display = state.uploadedFiles[1] ? '' : 'none'; }
    if (thumb2) { var c2 = thumb2.querySelector('.vinyl-preview__thumb-check'); if (c2) c2.style.display = state.uploadedFiles[2] ? '' : 'none'; }

    var allThumb = root.querySelector('.vinyl-preview__thumb[data-upload-index="0"]');
    if (allThumb) {
      var allDone = !!state.uploadedFiles[1] && !!state.uploadedFiles[2];
      var allCheck = allThumb.querySelector('.vinyl-preview__thumb-check');
      if (allCheck) allCheck.style.display = allDone ? '' : 'none';
    }
  }

  function updateAddonsTotal() {
    var total = 0;
    qAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) { total += parseFloat(cb.dataset.value || 0); });
    state.addonsTotal = total;
    updatePriceDisplay();
  }

  /* ==========================================================================
     DYNAMIC PRICING (ported from main constructor)
     ========================================================================== */
  function getCurrencyRate() {
    try { return parseFloat(Shopify.currency.rate) || 1; } catch(e) { return 1; }
  }

  function formatMoney(cents) {
    var symbol = config.currencySymbol || '$';
    var raw = (Math.abs(cents) / 100).toFixed(2);
    var amount = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return cents < 0 ? ('-' + symbol + amount) : (symbol + amount);
  }

  function formatMoneyTheme(cents) {
    var fmt = config.moneyFormat || ('$' + '{{amount}}');
    var absVal = Math.abs(cents);
    var dollars = (absVal / 100).toFixed(2);
    var formatted = dollars.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    var result = fmt.replace(/\{\{\s*amount\s*\}\}/, formatted)
                    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(absVal / 100).toString())
                    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dollars.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
                    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(absVal / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'));
    return cents < 0 ? '-' + result : result;
  }

  function updatePriceDisplay() {
    var rate = getCurrencyRate();
    var addonsCentsUSD = Math.round(state.addonsTotal * 100);
    var addonsCents, baseCents;

    if (_isShopifyPayments && _isMultiCurrency) {
      baseCents = state.basePrice;
      addonsCents = Math.round(addonsCentsUSD * rate);
    } else {
      baseCents = state.basePrice;
      addonsCents = addonsCentsUSD;
    }

    var totalPerItem = baseCents + addonsCents;

    var discount = 0;
    if (state.quantity >= 6) discount = 0.15;
    else if (state.quantity >= 3) discount = 0.10;

    var discountedPerItem = Math.round(totalPerItem * (1 - discount));
    var totalPrice = discountedPerItem * state.quantity;

    var baseCompareCents = state.discountRatio > 0
      ? Math.round(baseCents / (1 - state.discountRatio))
      : 0;
    var compareTotalPerItem = baseCompareCents > 0
      ? baseCompareCents + addonsCents
      : 0;

    var savings = compareTotalPerItem > discountedPerItem ? compareTotalPerItem - discountedPerItem : 0;

    var priceEl = root.querySelector('.vinyl-price__current .money');
    var compareWrapper = root.querySelector('.vinyl-price__compare');
    var compareEl = compareWrapper ? compareWrapper.querySelector('.money') : null;
    var savingsAmountEl = root.querySelector('.vinyl-savings__amount .money');
    var savingsTotalEl = root.querySelector('.vinyl-savings__total .money') || root.querySelector('.vinyl-savings__total');
    var discountPctEl = root.querySelector('.vinyl-discount-percent');
    var badgeEl = root.querySelector('.vinyl-price__badge');

    var useThemeFormat = (_isShopifyPayments && _isMultiCurrency);
    var fmtFn = useThemeFormat ? formatMoneyTheme : formatMoney;

    if (priceEl) {
      priceEl.innerHTML = fmtFn(discountedPerItem);
      if (!useThemeFormat) priceEl.dataset.basecut4s = discountedPerItem;
    }

    if (compareWrapper) {
      if (savings > 0 && compareEl) {
        compareEl.innerHTML = fmtFn(compareTotalPerItem);
        if (!useThemeFormat) compareEl.dataset.basecut4s = compareTotalPerItem;
        compareWrapper.classList.remove('visually-hidden');
      } else {
        compareWrapper.classList.add('visually-hidden');
      }
    }

    if (savingsAmountEl) {
      savingsAmountEl.innerHTML = fmtFn(savings);
      if (!useThemeFormat) savingsAmountEl.dataset.basecut4s = savings;
    }
    if (savingsTotalEl) {
      savingsTotalEl.innerHTML = fmtFn(totalPrice);
      if (!useThemeFormat) savingsTotalEl.dataset.basecut4s = totalPrice;
    }

    if (badgeEl) {
      if (savings > 0 && compareTotalPerItem > 0) {
        var pct = Math.round(savings / compareTotalPerItem * 100);
        if (discountPctEl) discountPctEl.textContent = pct + '%';
        badgeEl.classList.remove('visually-hidden');
      } else {
        badgeEl.classList.add('visually-hidden');
      }
    }

    updateAddonLabels();

    if (!useThemeFormat) {
      triggerCurrencyConverter();
    }
  }

  function updateAddonLabels() {
    var useThemeFormat = (_isShopifyPayments && _isMultiCurrency);
    var rate = getCurrencyRate();
    var activeCurr = 'USD';
    try { activeCurr = Shopify.currency.active || 'USD'; } catch(e) {}

    root.querySelectorAll('.vinyl-addon__price span.money').forEach(function(el) {
      var priceUSD = parseFloat(el.getAttribute('data-addon-price')) || 0;
      if (useThemeFormat) {
        var centsLocal = Math.round(priceUSD * 100 * rate);
        el.innerHTML = formatMoneyTheme(centsLocal);
      } else if (activeCurr !== 'USD' && rate !== 1) {
        var centsLocal = Math.round(priceUSD * 100 * rate);
        var converted = (centsLocal / 100).toFixed(2);
        el.textContent = (config.currencySymbol || '$') + converted;
        delete el.dataset.basecut4s;
      } else {
        el.textContent = '$' + priceUSD.toFixed(2);
        el.dataset.basecut4s = Math.round(priceUSD * 100);
      }
    });
  }

  function triggerCurrencyConverter() {
    try {
      window._vinylCurrencyUpdating = true;
      if (typeof jQuery_T4NT !== 'undefined') {
        jQuery_T4NT('body').trigger('currency:update');
      } else if (typeof jQuery !== 'undefined') {
        jQuery('body').trigger('currency:update');
      } else {
        document.body.dispatchEvent(new CustomEvent('currency:update'));
      }
      setTimeout(function() { window._vinylCurrencyUpdating = false; }, 0);
    } catch(e) {
      window._vinylCurrencyUpdating = false;
    }
  }

  /* ==========================================================================
     FILE UPLOAD — show / update / delete
     ========================================================================== */
  function showUploadedFile(index, fileName, resolution, previewUrl, fileUrl, origW, origH, mimeType) {
    var fileEl = q('.vinyl-uploaded-file[data-index="' + index + '"]');
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (!fileEl) return;
    fileEl.classList.remove('visually-hidden');
    if (uploader) uploader.style.display = 'none';
    var previewImg = fileEl.querySelector('.preview_img');
    if (previewImg) previewImg.src = previewUrl;
    var resolvedMime = mimeType || mimeFromFilename(fileName) || 'image/jpeg';
    state.uploadedFiles[index] = { name: fileName, resolution: resolution, previewUrl: previewUrl, fileUrl: fileUrl || previewUrl, blob: null, mime: resolvedMime };
    if (previewUrl && previewUrl.indexOf('data:') === 0) {
      fetch(previewUrl).then(function(r) { return r.blob(); }).then(function(blob) {
        state.uploadedFiles[index].blob = new File([blob], fileName, { type: resolvedMime });
      });
    }
    updatePreview(index, previewUrl);
    var slideMap = { 1: 'front-cover', 2: 'back-cover' };
    if (slideMap[index]) activatePreviewSlide(slideMap[index]);
    updateDpiBadge(index, origW || 0, origH || 0);
    checkCustomizationStatus();
    saveState();
  }

  function updateDpiBadge(index, width, height) {
    var badge = q('.vinyl-dpi-badge[data-index="' + index + '"]');
    if (!badge || !width || !height) return;
    var printSize = 13;
    var dpi = parseInt(width / printSize, 10);
    var tierClass, tierLabel;
    if (dpi > 300) { tierClass = 'vinyl-dpi-badge--high'; tierLabel = 'High quality'; }
    else if (dpi > 150) { tierClass = 'vinyl-dpi-badge--good'; tierLabel = 'Good quality'; }
    else { tierClass = 'vinyl-dpi-badge--low'; tierLabel = 'Low quality'; }
    badge.className = 'vinyl-dpi-badge ' + tierClass;
    badge.textContent = tierLabel + ' Print (' + dpi + ' DPI)';
  }

  function updatePreview(index, imageUrl) {
    var map = index === 1
      ? { slide: 'front-cover', sel: '.vinyl-preview__cover--front .vinyl-preview__image' }
      : index === 2
        ? { slide: 'back-cover', sel: '.vinyl-preview__cover--back .vinyl-preview__image' }
        : null;
    if (!map) return;
    qAll(map.sel).forEach(function(img) { img.src = imageUrl || ''; img.style.display = imageUrl ? 'block' : 'none'; });
    qAll('.vinyl-preview__slide[data-slide="' + map.slide + '"] .vinyl-preview__placeholder').forEach(function(ph) { ph.style.display = imageUrl ? 'none' : ''; });
    var coverEl = q('.vinyl-preview__slide[data-slide="' + map.slide + '"] .vinyl-preview__cover');
    if (coverEl) coverEl.classList.toggle('vinyl-preview__cover--has-image', !!imageUrl);
    var thumb = q('.vinyl-preview__thumb[data-upload-index="' + index + '"]');
    if (thumb) {
      var thumbImg = thumb.querySelector('.vinyl-preview__thumb-img');
      var thumbIcon = thumb.querySelector('.vinyl-preview__thumb-icon');
      if (thumbImg && thumbIcon) {
        thumbImg.src = imageUrl || '';
        thumbImg.style.display = imageUrl ? '' : 'none';
        thumbIcon.style.display = imageUrl ? 'none' : '';
      }
    }
    updateFullSetGrid(index, imageUrl);
    updateAllThumb();
  }

  function updateFullSetGrid(index, imageUrl) {
    var fullKey = index === 1 ? 'front' : index === 2 ? 'back' : null;
    if (!fullKey) return;
    var fullCell = root.querySelector('.vinyl-preview__full-cell[data-full="' + fullKey + '"]');
    if (!fullCell) return;
    var fImg = fullCell.querySelector('.vinyl-preview__full-img');
    var fPh = fullCell.querySelector('.vinyl-preview__placeholder');
    if (fImg) { fImg.src = imageUrl || ''; fImg.style.display = imageUrl ? 'block' : 'none'; }
    if (fPh) fPh.style.display = imageUrl ? 'none' : '';
  }

  function updateAllThumb() {
    var allThumb = root.querySelector('.vinyl-preview__thumb[data-upload-index="0"]');
    if (!allThumb) return;
    var thumbImg = allThumb.querySelector('.vinyl-preview__thumb-img');
    var thumbIcon = allThumb.querySelector('.vinyl-preview__thumb-icon');
    if (!thumbImg || !thumbIcon) return;
    var firstUrl = '';
    for (var i = 1; i <= 2; i++) {
      if (state.uploadedFiles[i] && (state.uploadedFiles[i].previewUrl || state.uploadedFiles[i].fileUrl)) {
        firstUrl = state.uploadedFiles[i].previewUrl || state.uploadedFiles[i].fileUrl;
        break;
      }
    }
    if (firstUrl) { thumbImg.src = firstUrl; thumbImg.style.display = ''; thumbIcon.style.display = 'none'; }
    else { thumbImg.src = ''; thumbImg.style.display = 'none'; thumbIcon.style.display = ''; }
  }

  function deleteUploadedFile(index) {
    var fileEl = q('.vinyl-uploaded-file[data-index="' + index + '"]');
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (fileEl) fileEl.classList.add('visually-hidden');
    if (uploader) uploader.style.display = '';
    delete state.uploadedFiles[index];
    updatePreview(index, null);
    checkCustomizationStatus();
  }

  /* ==========================================================================
     CROP MODAL
     ========================================================================== */
  function openCropModal(imageSource, index, sourceMime, sourceName) {
    if (!dom.cropModal || !dom.cropImage) return;
    state.cropTargetIndex = index;
    state.cropSourceMime = sourceMime || (imageSource && imageSource.type) || mimeFromFilename(sourceName) || 'image/jpeg';
    state.cropSourceName = sourceName || (imageSource && imageSource.name) || '';
    if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
    dom.cropImage.onload = null;
    dom.cropImage.src = '';
    function initCropper() {
      if (typeof Cropper === 'undefined') { setTimeout(initCropper, 300); return; }
      if (!dom.cropImage.complete || dom.cropImage.naturalWidth === 0) { setTimeout(initCropper, 200); return; }
      if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
      dom.cropImage.style.opacity = '1';
      state.cropper = new Cropper(dom.cropImage, {
        aspectRatio: 1, viewMode: 2, autoCrop: true, autoCropArea: 1,
        movable: true, zoomable: true, scalable: true, rotatable: true,
        responsive: true, background: true, guides: true, center: true,
        highlight: true, cropBoxMovable: true, cropBoxResizable: true,
        dragMode: 'move', minContainerWidth: 200, minContainerHeight: 200
      });
    }
    dom.cropImage.onload = initCropper;
    dom.cropImage.onerror = function() { console.error('[Vinyl3] Failed to load crop image'); };
    if (typeof imageSource === 'string') dom.cropImage.src = imageSource;
    else dom.cropImage.src = URL.createObjectURL(imageSource);
    dom.cropModal.style.display = 'flex';
    setTimeout(initCropper, 500);
    setTimeout(initCropper, 1500);
  }

  function handleCropConfirm() {
    var index = state.cropTargetIndex;
    var sourceMime = state.cropSourceMime || 'image/jpeg';
    if (state.cropper) {
      var cropData = state.cropper.getData();
      var origCropW = Math.round(cropData.width);
      var origCropH = Math.round(cropData.height);
      var canvas = state.cropper.getCroppedCanvas({ width: origCropW, height: origCropH, imageSmoothingQuality: 'high' });
      if (canvas) {
        encodeCanvasPreservingFormat(canvas, sourceMime, MAX_COVER_BYTES).then(function(result) {
          uploadToFilestack(result.dataUrl, index, result.width, result.height, origCropW, origCropH, result.mime);
        });
      }
    } else {
      closeCropModal();
    }
  }

  function uploadToFilestack(dataUrl, index, width, height, origW, origH, mimeType) {
    var animation = dom.cropModal ? dom.cropModal.querySelector('.vinyl-crop-modal__upload-animation') : null;
    var actions = dom.cropModal ? dom.cropModal.querySelector('.vinyl-crop-modal__actions') : null;

    if (animation) animation.style.display = 'block';
    if (actions) actions.style.display = 'none';

    var resolvedMime = mimeType || 'image/jpeg';
    var ext = extFromMime(resolvedMime);
    var filename = 'vinyl_image_' + index + '.' + ext;

    fetch(dataUrl)
      .then(function(res) { return res.blob(); })
      .then(function(blob) {
        var imageBlob = new File([blob], filename, { type: resolvedMime });

        function tryFilestack() {
          if (!FILESTACK_API_KEY) return Promise.reject('no key');
          var fd = new FormData();
          fd.append('fileUpload', imageBlob, filename);
          fd.append('filename', filename);
          fd.append('mimetype', resolvedMime);
          return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK_API_KEY, {
            method: 'POST', body: fd
          }).then(function(res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          }).then(function(text) {
            try {
              var data = JSON.parse(text);
              // Return raw Filestack handle URL with ?dl=true so a click in
              // Shopify Admin triggers an attachment download (Content-
              // Disposition switches from `inline` to `attachment`) instead
              // of opening the image in a new tab. Original filename is
              // preserved via the multipart `filename` field above.
              if (data.url) return data.url + '?dl=true';
              throw new Error('No URL');
            } catch(e) {
              if (text.indexOf('blocked') !== -1) throw new Error('Filestack blocked');
              throw e;
            }
          });
        }

        return tryFilestack().catch(function(err) {
          console.warn('[Vinyl V4] Filestack crop failed, using Shopify CDN:', err.message || err);
          return uploadBlobToShopifyCdn(imageBlob, filename);
        });
      })
      .then(function(result) {
        var fileUrl = (typeof result === 'string' && result.indexOf('://') !== -1) ? result : dataUrl;
        console.log('[Vinyl V4] Crop image ' + index + ' uploaded (' + resolvedMime + '):', fileUrl.substring(0, 80));
        finalizeCrop(index, fileUrl, dataUrl, width, height, origW, origH, resolvedMime, filename);
      })
      .catch(function() {
        finalizeCrop(index, dataUrl, dataUrl, width, height, origW, origH, resolvedMime, filename);
      });
  }

  function finalizeCrop(index, fileUrl, previewUrl, width, height, origW, origH, mimeType, fileName) {
    var resolvedMime = mimeType || 'image/jpeg';
    var resolvedName = fileName || ('vinyl_image_' + index + '.' + extFromMime(resolvedMime));
    var resolution = width + ' x ' + height + 'px';
    showUploadedFile(index, resolvedName, resolution, previewUrl, fileUrl, origW || width, origH || height, resolvedMime);
    closeCropModal();
  }

  function closeCropModal() {
    if (state.cropper) { state.cropper.destroy(); state.cropper = null; }
    if (dom.cropModal) {
      dom.cropModal.style.display = 'none';
      var animation = dom.cropModal.querySelector('.vinyl-crop-modal__upload-animation');
      var actions = dom.cropModal.querySelector('.vinyl-crop-modal__actions');
      if (animation) animation.style.display = 'none';
      if (actions) actions.style.display = '';
    }
    state.cropTargetIndex = null;
    state.cropSourceMime = null;
    state.cropSourceName = null;
  }

  function bindCropModal() {
    if (dom.cropConfirm) dom.cropConfirm.addEventListener('click', handleCropConfirm);
    if (dom.cropCancel) dom.cropCancel.addEventListener('click', closeCropModal);
  }

  /* ==========================================================================
     UPLOAD MODAL — Fixed: no double file-picker
     ========================================================================== */
  function showConvertingState(index, show) {
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (!uploader) return;
    var converting = uploader.querySelector('.vinyl-dropzone-modal__converting');
    if (converting) converting.style.display = show ? 'flex' : 'none';
  }

  var ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf', 'image/tiff'];
  var MAX_COVER_BYTES = 15728640;

  function extFromMime(mime) {
    if (!mime) return 'jpg';
    if (mime.indexOf('png') !== -1) return 'png';
    if (mime.indexOf('webp') !== -1) return 'webp';
    return 'jpg';
  }

  function mimeFromFilename(name) {
    if (!name) return null;
    var lower = String(name).toLowerCase();
    if (lower.indexOf('.png') !== -1) return 'image/png';
    if (lower.indexOf('.webp') !== -1) return 'image/webp';
    if (lower.indexOf('.jpg') !== -1 || lower.indexOf('.jpeg') !== -1) return 'image/jpeg';
    return null;
  }

  function normalizeOutputMime(sourceMime) {
    if (!sourceMime) return 'image/jpeg';
    var m = String(sourceMime).toLowerCase();
    if (m.indexOf('png') !== -1) return 'image/png';
    if (m.indexOf('webp') !== -1) return 'image/webp';
    return 'image/jpeg';
  }

  function encodeCanvasPreservingFormat(canvas, sourceMime, maxBytes) {
    var outMime = normalizeOutputMime(sourceMime);
    return new Promise(function(resolve) {
      function readerOf(blob, mime) {
        var reader = new FileReader();
        reader.onload = function() {
          resolve({ dataUrl: reader.result, width: canvas.width, height: canvas.height, mime: mime, size: blob.size });
        };
        reader.readAsDataURL(blob);
      }
      function tryEncode(mime, quality, onDone, onFail) {
        canvas.toBlob(function(blob) {
          if (!blob) { onFail(); return; }
          onDone(blob);
        }, mime, quality);
      }
      if (outMime === 'image/png') {
        tryEncode('image/png', undefined, function(blob) {
          var sizeKB = (blob.size / 1024).toFixed(0);
          console.log('[Vinyl V4] PNG lossless → ' + sizeKB + 'KB (' + canvas.width + 'x' + canvas.height + ')');
          if (blob.size <= maxBytes) { readerOf(blob, 'image/png'); return; }
          console.warn('[Vinyl V4] PNG ' + sizeKB + 'KB exceeds limit, falling back to JPEG q=0.95');
          tryEncode('image/jpeg', 0.95, function(jb) { readerOf(jb, 'image/jpeg'); }, function() { readerOf(blob, 'image/png'); });
        }, function() {
          tryEncode('image/jpeg', 0.95, function(jb) { readerOf(jb, 'image/jpeg'); }, function() {
            resolve({ dataUrl: canvas.toDataURL('image/jpeg', 0.95), width: canvas.width, height: canvas.height, mime: 'image/jpeg', size: 0 });
          });
        });
        return;
      }
      var quality = 0.95;
      var minQuality = 0.75;
      function attempt() {
        tryEncode(outMime, quality, function(blob) {
          var sizeKB = (blob.size / 1024).toFixed(0);
          var limitKB = (maxBytes / 1024).toFixed(0);
          console.log('[Vinyl V4] Encode ' + outMime + ' q=' + quality.toFixed(2) + ' → ' + sizeKB + 'KB / ' + limitKB + 'KB (' + canvas.width + 'x' + canvas.height + ')');
          if (blob.size <= maxBytes || quality <= minQuality) { readerOf(blob, outMime); return; }
          quality = Math.max(minQuality, quality - 0.05);
          attempt();
        }, function() {
          resolve({ dataUrl: canvas.toDataURL(outMime, quality), width: canvas.width, height: canvas.height, mime: outMime, size: 0 });
        });
      }
      attempt();
    });
  }

  /* ==========================================================================
     PDF / TIFF PASSTHROUGH (V4)
     The customer's original PDF/TIFF must arrive in the order untouched.
     We render the first page to PNG only as a UI thumbnail / live-preview;
     the cart line item property points at the ORIGINAL file on Filestack.
     ========================================================================== */
  var __vinylScriptCache = {};
  function loadScriptOnce(src) {
    if (!src) return Promise.reject(new Error('Missing script URL'));
    if (__vinylScriptCache[src]) return __vinylScriptCache[src];
    __vinylScriptCache[src] = new Promise(function(resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function() { resolve(); };
      s.onerror = function() { reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(s);
    });
    return __vinylScriptCache[src];
  }

  function ensurePdfJs() {
    if (typeof window.pdfjsLib !== 'undefined') {
      if (config.pdfWorkerUrl && window.pdfjsLib.GlobalWorkerOptions && !window.pdfjsLib.GlobalWorkerOptions.workerSrc) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = config.pdfWorkerUrl;
      }
      return Promise.resolve(window.pdfjsLib);
    }
    return loadScriptOnce(config.pdfJsUrl).then(function() {
      if (window.pdfjsLib && config.pdfWorkerUrl) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = config.pdfWorkerUrl;
      }
      return window.pdfjsLib;
    });
  }

  function ensureUtif() {
    if (typeof window.UTIF !== 'undefined') return Promise.resolve(window.UTIF);
    return loadScriptOnce(config.utifUrl).then(function() { return window.UTIF; });
  }

  function isPdfOrTiffFile(file) {
    if (!file) return null;
    var name = (file.name || '').toLowerCase();
    var mime = (file.type || '').toLowerCase();
    if (mime === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
    if (mime === 'image/tiff' || mime === 'image/tif' || name.endsWith('.tif') || name.endsWith('.tiff')) return 'tiff';
    return null;
  }

  function detectPassthroughMime(file) {
    var kind = isPdfOrTiffFile(file);
    if (kind === 'pdf')  return 'application/pdf';
    if (kind === 'tiff') return 'image/tiff';
    return file && file.type ? file.type : 'application/octet-stream';
  }

  function renderPdfFirstPageToPngDataUrl(file) {
    return ensurePdfJs().then(function() {
      return file.arrayBuffer();
    }).then(function(buf) {
      return window.pdfjsLib.getDocument({ data: new Uint8Array(buf) }).promise;
    }).then(function(pdf) {
      if (pdf.numPages > 1) {
        console.log('[Vinyl V4 PDF] file has', pdf.numPages, 'pages — preview = page 1, original PDF (all pages) goes to order');
      }
      return pdf.getPage(1);
    }).then(function(page) {
      var raw = page.getViewport({ scale: 1 });
      var maxDim = 1600;
      var scale = Math.min(maxDim / Math.max(raw.width, raw.height), 2);
      if (!isFinite(scale) || scale <= 0) scale = 1;
      var viewport = page.getViewport({ scale: scale });
      var canvas = document.createElement('canvas');
      canvas.width  = Math.max(1, Math.round(viewport.width));
      canvas.height = Math.max(1, Math.round(viewport.height));
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function() {
        return canvas.toDataURL('image/png');
      });
    });
  }

  function renderTiffFirstPageToPngDataUrl(file) {
    return ensureUtif().then(function() {
      return file.arrayBuffer();
    }).then(function(buf) {
      var bytes = new Uint8Array(buf);
      var ifds = window.UTIF.decode(bytes);
      if (!ifds || !ifds.length) throw new Error('Empty TIFF');
      if (ifds.length > 1) {
        console.log('[Vinyl V4 TIFF] file has', ifds.length, 'images — preview = first, original TIFF goes to order');
      }
      window.UTIF.decodeImage(bytes, ifds[0]);
      var w = ifds[0].width, h = ifds[0].height;
      if (!w || !h) throw new Error('TIFF has no dimensions');
      var rgba = window.UTIF.toRGBA8(ifds[0]);
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      var imageData = ctx.createImageData(w, h);
      imageData.data.set(rgba);
      ctx.putImageData(imageData, 0, 0);
      return canvas.toDataURL('image/png');
    });
  }

  function makePlaceholderPreviewDataUrl(label) {
    var canvas = document.createElement('canvas');
    canvas.width = 600; canvas.height = 600;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#F4F4F4'; ctx.fillRect(0, 0, 600, 600);
    ctx.fillStyle = '#999999';
    ctx.font = 'bold 80px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(String(label || 'FILE').toUpperCase(), 300, 300);
    return canvas.toDataURL('image/png');
  }

  function registerPassthroughUpload(index, originalFile, previewDataUrl, originalFileUrl) {
    var fileEl  = q('.vinyl-uploaded-file[data-index="' + index + '"]');
    var uploader = q('.vinyl-uploader[data-index="' + index + '"]');
    if (fileEl) {
      fileEl.classList.remove('visually-hidden');
      var previewImg = fileEl.querySelector('.preview_img');
      if (previewImg) previewImg.src = previewDataUrl;
    }
    if (uploader) uploader.style.display = 'none';

    var passthroughMime = detectPassthroughMime(originalFile);

    // upload.blob = ORIGINAL pdf/tiff File (not the PNG preview) so that
    // if Filestack/CDN ever fails to return a URL, the cart's multipart
    // /cart/add upload still delivers the customer's original file.
    state.uploadedFiles[index] = {
      name: originalFile.name || 'file',
      resolution: '',
      previewUrl: previewDataUrl,
      fileUrl: originalFileUrl,
      blob: originalFile,
      mime: passthroughMime,
      isPassthrough: true
    };
    precacheImageForCanvas(index);
    updatePreview(index, previewDataUrl);
    var slideMap = { 1: 'front-cover', 2: 'back-cover' };
    if (slideMap[index] && typeof activatePreviewSlide === 'function') activatePreviewSlide(slideMap[index]);
    checkCustomizationStatus();
    saveState();
  }

  function handlePassthroughFile(file, index) {
    var kind = isPdfOrTiffFile(file);
    if (!kind) return false;
    showConvertingState(index, true);

    var renderPromise = (kind === 'pdf')
      ? renderPdfFirstPageToPngDataUrl(file).catch(function(err) {
          console.warn('[Vinyl V4 PDF] render failed, using placeholder:', err && err.message || err);
          return makePlaceholderPreviewDataUrl('PDF');
        })
      : renderTiffFirstPageToPngDataUrl(file).catch(function(err) {
          console.warn('[Vinyl V4 TIFF] render failed, using placeholder:', err && err.message || err);
          return makePlaceholderPreviewDataUrl('TIFF');
        });

    renderPromise.then(function(previewDataUrl) {
      return uploadBlobToFilestack(file, file.name).then(function(result) {
        showConvertingState(index, false);
        var resolvedFileUrl = (typeof result === 'string' && result.indexOf('://') !== -1)
          ? result
          : previewDataUrl;
        console.log('[Vinyl V4] ' + kind.toUpperCase() + ' passthrough uploaded — order link:', resolvedFileUrl);
        registerPassthroughUpload(index, file, previewDataUrl, resolvedFileUrl);
      });
    }).catch(function(err) {
      showConvertingState(index, false);
      console.error('[Vinyl V4] ' + kind.toUpperCase() + ' passthrough failed:', err);
      alert('Failed to upload ' + kind.toUpperCase() + ' file: ' + (err && err.message || err));
    });
    return true;
  }

  function openUploadModal(uploader, index) {
    var modalWrapper = uploader.querySelector('.vinyl-upload-modal-wrapper');
    if (!modalWrapper) return;
    modalWrapper.classList.add('active');
    var dropArea = modalWrapper.querySelector('.vinyl-dropzone-modal__area');
    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg,image/png,image/webp,application/pdf,image/tiff,.heic';
    fileInput.style.display = 'none';

    function handleFile(file) {
      var ext = file.name.toLowerCase().split('.').pop();
      var rawMime = file.type ? file.type.toLowerCase() : '';
      if (ext !== 'heic' && ext !== 'heif') {
        if (rawMime && ALLOWED_MIME_TYPES.indexOf(rawMime) === -1) {
          alert('Unsupported file format: ' + (rawMime || ext) + '.\nAllowed: JPEG, PNG, WebP, PDF, TIFF.');
          return;
        }
      }
      var sourceMime = (rawMime === 'image/png' || rawMime === 'image/webp' || rawMime === 'image/jpeg')
        ? rawMime
        : (mimeFromFilename(file.name) || (ext === 'png' ? 'image/png' : ext === 'webp' ? 'image/webp' : 'image/png'));
      modalWrapper.classList.remove('active');
      if (isPdfOrTiffFile(file)) {
        handlePassthroughFile(file, index);
        fileInput.remove();
        return;
      }
      if (ext === 'heic' || ext === 'heif') {
        showConvertingState(index, true);
        if (typeof heic2any !== 'undefined') {
          heic2any({ blob: file, toType: 'image/png' })
            .then(function(blob) { showConvertingState(index, false); openCropModal(blob, index, 'image/png', 'converted_' + Date.now() + '.png'); })
            .catch(function() { showConvertingState(index, false); openCropModal(file, index, 'image/png', file.name); });
        } else { showConvertingState(index, false); openCropModal(file, index, 'image/png', file.name); }
      } else {
        var reader = new FileReader();
        reader.onload = function(e) { openCropModal(e.target.result, index, sourceMime, file.name); };
        reader.readAsDataURL(file);
      }
      fileInput.remove();
    }

    fileInput.addEventListener('change', function(e) { if (e.target.files.length) handleFile(e.target.files[0]); });

    if (dropArea) {
      var clickHandler = function(e) {
        e.stopPropagation();
        fileInput.click();
      };
      dropArea.addEventListener('click', clickHandler, { once: true });
      dropArea.addEventListener('dragover', function(e) { e.preventDefault(); dropArea.classList.add('dragover'); });
      dropArea.addEventListener('dragleave', function() { dropArea.classList.remove('dragover'); });
      dropArea.addEventListener('drop', function(e) { e.preventDefault(); dropArea.classList.remove('dragover'); if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]); });
    }

    document.body.appendChild(fileInput);
  }

  function bindUploaders() {
    qAll('.vinyl-uploader').forEach(function(uploader) {
      var index = parseInt(uploader.dataset.index, 10);
      if (index !== 1 && index !== 2) return;

      var modalWrapper = uploader.querySelector('.vinyl-upload-modal-wrapper');
      var closeBtn = modalWrapper ? modalWrapper.querySelector('.vinyl-dropzone-modal__close') : null;
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); if (modalWrapper) modalWrapper.classList.remove('active'); });
      }
      if (modalWrapper) {
        modalWrapper.addEventListener('click', function(e) { if (e.target === modalWrapper) modalWrapper.classList.remove('active'); });
      }

      var defaultLabel = uploader.querySelector('.vinyl-uploader__default');
      if (defaultLabel) {
        defaultLabel.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          openUploadModal(uploader, index);
        });
      }
    });

    qAll('.vinyl-uploaded-file__delete').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var fileEl = btn.closest('.vinyl-uploaded-file');
        if (fileEl) deleteUploadedFile(parseInt(fileEl.dataset.index, 10));
      });
    });
    qAll('.vinyl-uploaded-file__edit').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var fileEl = btn.closest('.vinyl-uploaded-file');
        if (!fileEl) return;
        var idx = parseInt(fileEl.dataset.index, 10);
        var up = q('.vinyl-uploader[data-index="' + idx + '"]');
        if (up) {
          var wasHidden = up.style.display === 'none';
          if (wasHidden) up.style.display = '';
          openUploadModal(up, idx);
          if (wasHidden) {
            var mw = up.querySelector('.vinyl-upload-modal-wrapper');
            if (mw) {
              var obs = new MutationObserver(function() {
                if (!mw.classList.contains('active')) { up.style.display = 'none'; obs.disconnect(); }
              });
              obs.observe(mw, { attributes: true, attributeFilter: ['class'] });
            }
          }
        }
      });
    });
  }

  /* ==========================================================================
     COVER TEXT PREVIEW OVERLAY (ported from main constructor)
     ========================================================================== */
  function updateCoverTextPreview(side) {
    var overlayKey = 'cover-' + side;
    var overlay = root.querySelector('[data-text-overlay="' + overlayKey + '"]');
    var gridOverlay = root.querySelector('[data-text-overlay-grid="' + overlayKey + '"]');
    var data = state.coverText[side];
    if (!data) return;

    if (!data.text) {
      if (overlay) {
        overlay.style.display = 'none';
        var ts = overlay.querySelector('.vinyl-overlay__text');
        if (ts) { ts.textContent = ''; ts.style.textDecoration = 'none'; ts.style.fontWeight = 'normal'; ts.style.fontStyle = 'normal'; }
      }
      if (gridOverlay) { gridOverlay.style.display = 'none'; gridOverlay.textContent = ''; }
      return;
    }

    var fontFamily = '"' + data.font + '", sans-serif';
    var fontWeight = data.bold ? 'bold' : 'normal';
    var fontStyle = data.italic ? 'italic' : 'normal';
    var textDecor = data.underline ? 'underline' : 'none';
    var lineHeight = data.lineHeight || '1.2';

    if (overlay) {
      var textSpan = overlay.querySelector('.vinyl-overlay__text');
      if (textSpan) {
        textSpan.textContent = data.text;
        textSpan.style.textDecoration = textDecor;
        textSpan.style.fontWeight = fontWeight;
        textSpan.style.fontStyle = fontStyle;
      }
      overlay.style.fontFamily = fontFamily;
      overlay.style.color = data.color;
      var basePx = parseInt(data.size, 10) || 24;
      var scaledPx = Math.max(12, Math.min(36, Math.round(basePx * 0.45)));
      overlay.style.fontSize = scaledPx + 'px';
      overlay.style.lineHeight = lineHeight;
      overlay.style.fontWeight = fontWeight;
      overlay.style.fontStyle = fontStyle;
      overlay.style.textDecoration = 'none';
      overlay.style.overflow = 'visible';
      var zMap = { A: 5, A2: 6, A3: 7, B: 5, B2: 6, B3: 7, B4: 8 };
      overlay.style.zIndex = zMap[side] || 5;
      overlay.style.display = 'block';
      overlay.style.position = 'absolute';
      overlay.style.inset = 'auto';
      overlay.style.left = (data.x || 50) + '%';
      overlay.style.top = (data.y || 50) + '%';
      overlay.style.width = (data.w || 50) + '%';
      overlay.style.transform = 'translate(-50%, -50%)';
    }

    if (gridOverlay) {
      gridOverlay.textContent = data.text;
      gridOverlay.style.display = 'block';
      gridOverlay.style.fontFamily = fontFamily;
      gridOverlay.style.color = data.color;
      var gridPx = parseInt(data.size, 10) || 24;
      var gridScaled = Math.max(7, Math.round(gridPx * 0.22));
      gridOverlay.style.fontSize = gridScaled + 'px';
      gridOverlay.style.lineHeight = lineHeight;
      gridOverlay.style.fontWeight = fontWeight;
      gridOverlay.style.fontStyle = fontStyle;
      gridOverlay.style.textDecoration = textDecor;
      gridOverlay.style.overflow = 'visible';
      gridOverlay.style.position = 'absolute';
      gridOverlay.style.inset = 'auto';
      gridOverlay.style.left = (data.x || 50) + '%';
      gridOverlay.style.top = (data.y || 50) + '%';
      gridOverlay.style.transform = 'translate(-50%, -50%)';
      gridOverlay.style.width = (data.w || 50) + '%';
    }

    saveState();
  }

  function refreshSiblingPreviews(side) {
    var prefix = side.charAt(0);
    COVER_KEYS.forEach(function(k) {
      if (k !== side && k.charAt(0) === prefix && state.coverText[k] && state.coverText[k].text) updateCoverTextPreview(k);
    });
  }

  function syncGridOverlay(key) {
    var gridOverlay = root.querySelector('[data-text-overlay-grid="cover-' + key + '"]');
    if (!gridOverlay || !state.coverText[key]) return;
    var data = state.coverText[key];
    gridOverlay.style.left = (data.x || 50) + '%';
    gridOverlay.style.top = (data.y || 50) + '%';
    gridOverlay.style.width = (data.w || 50) + '%';
  }

  /* ==========================================================================
     DRAG-AND-DROP OVERLAYS (ported from main constructor)
     ========================================================================== */
  function getPointerPos(e) {
    if (e.touches && e.touches.length) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    return { x: e.clientX, y: e.clientY };
  }

  function makeDraggable(el, fieldKey) {
    var isDragging = false;
    var startX, startY, elStartX, elStartY;
    function onDown(e) {
      if (e.target.closest('.vinyl-overlay__resize')) return;
      if (!state.coverText[fieldKey] || !state.coverText[fieldKey].text) return;
      isDragging = true;
      var pos = getPointerPos(e);
      startX = pos.x; startY = pos.y;
      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      elStartX = (parseFloat(el.style.left) || 50) / 100 * rect.width;
      elStartY = (parseFloat(el.style.top) || 50) / 100 * rect.height;
      el.classList.add('dragging');
      e.preventDefault();
    }
    function onMove(e) {
      if (!isDragging) return;
      var pos = getPointerPos(e);
      var parent = el.parentElement;
      var rect = parent.getBoundingClientRect();
      var padX = rect.width * 0.05, padY = rect.height * 0.05;
      var newX = Math.max(padX, Math.min(rect.width - padX, elStartX + pos.x - startX));
      var newY = Math.max(padY, Math.min(rect.height - padY, elStartY + pos.y - startY));
      el.style.left = (newX / rect.width * 100) + '%';
      el.style.top = (newY / rect.height * 100) + '%';
    }
    function onUp() {
      if (!isDragging) return;
      isDragging = false;
      el.classList.remove('dragging');
      state.coverText[fieldKey].x = Math.round((parseFloat(el.style.left) || 50) * 10) / 10;
      state.coverText[fieldKey].y = Math.round((parseFloat(el.style.top) || 50) * 10) / 10;
      syncGridOverlay(fieldKey);
      saveState();
    }
    el.addEventListener('mousedown', onDown);
    el.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);
  }

  function makeResizable(overlay, fieldKey) {
    var handles = overlay.querySelectorAll('.vinyl-overlay__resize');
    if (!handles.length) return;
    var isResizing = false, startX, startW, dir;
    handles.forEach(function(handle) {
      function onDown(e) {
        isResizing = true;
        dir = parseInt(handle.dataset.resizeDir, 10) || 1;
        var pos = getPointerPos(e);
        startX = pos.x;
        startW = (state.coverText[fieldKey].w || 50) / 100 * overlay.parentElement.getBoundingClientRect().width;
        overlay.classList.add('resizing');
        e.preventDefault(); e.stopPropagation();
      }
      handle.addEventListener('mousedown', onDown);
      handle.addEventListener('touchstart', onDown, { passive: false });
    });
    function onMove(e) {
      if (!isResizing) return;
      var pos = getPointerPos(e);
      var parentW = overlay.parentElement.getBoundingClientRect().width;
      var newW = Math.max(parentW * 0.15, Math.min(parentW, startW + (pos.x - startX) * dir));
      overlay.style.width = (newW / parentW * 100) + '%';
    }
    function onUp() {
      if (!isResizing) return;
      isResizing = false;
      overlay.classList.remove('resizing');
      var w = Math.round(parseFloat(overlay.style.width) || 50);
      state.coverText[fieldKey].w = w;
      var wr = sid('coverWidth' + fieldKey);
      var wv = sid('coverWidthVal' + fieldKey);
      if (wr) wr.value = w;
      if (wv) wv.textContent = w + '%';
      syncGridOverlay(fieldKey);
      saveState();
    }
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchend', onUp);
  }

  function initDraggableOverlays() {
    COVER_KEYS.forEach(function(key) {
      var overlay = root.querySelector('[data-text-overlay="cover-' + key + '"]');
      if (!overlay) return;
      makeDraggable(overlay, key);
      makeResizable(overlay, key);
    });
  }

  /* ==========================================================================
     GOOGLE FONTS — preload & preview
     ========================================================================== */
  function preloadFont(fontFamily, bold, italic) {
    var weight = bold ? '700' : '400';
    var style = italic ? 'italic' : 'normal';
    if (document.fonts && document.fonts.load) {
      document.fonts.load(style + ' ' + weight + ' 16px "' + fontFamily + '"').catch(function() {});
    }
  }

  function applyFontPreviews() {
    root.querySelectorAll('.vinyl-font-select').forEach(function(select) {
      Array.from(select.options).forEach(function(opt) { opt.style.fontFamily = '"' + opt.value + '", sans-serif'; });
      select.style.fontFamily = '"' + select.value + '", sans-serif';
      select.addEventListener('change', function() { select.style.fontFamily = '"' + select.value + '", sans-serif'; });
    });
  }

  /* ==========================================================================
     COVER TEXT UI (ported from main constructor)
     ========================================================================== */
  function bindCoverTextUI() {
    var tabs = root.querySelectorAll('[data-cover-side]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var side = tab.dataset.coverSide;
        tabs.forEach(function(t) { t.classList.remove('vinyl-text-tab--active'); });
        tab.classList.add('vinyl-text-tab--active');
        root.querySelectorAll('.vinyl-cover-text-panel').forEach(function(p) {
          p.style.display = p.dataset.coverPanel === side ? '' : 'none';
        });
        activatePreviewSlide(side === 'A' ? 'front-cover' : 'back-cover');
      });
    });

    COVER_KEYS.forEach(function(side) {
      var textInput  = sid('coverText' + side);
      var fontSelect = sid('coverFont' + side);
      var sizeSelect = sid('coverSize' + side);
      var lhSelect   = sid('coverLineHeight' + side);
      var widthRange = sid('coverWidth' + side);
      var widthVal   = sid('coverWidthVal' + side);

      if (textInput) {
        textInput.addEventListener('focus', function() {
          var isFront = side.charAt(0) === 'A';
          activatePreviewSlide(isFront ? 'front-cover' : 'back-cover');
        });
        textInput.addEventListener('input', function() {
          state.coverText[side].text = textInput.value;
          updateCoverTextPreview(side);
          refreshSiblingPreviews(side);
          updateStepCheckmarks();
        });
      }
      if (fontSelect) fontSelect.addEventListener('change', function() {
        state.coverText[side].font = fontSelect.value;
        preloadFont(fontSelect.value, state.coverText[side].bold, state.coverText[side].italic);
        updateCoverTextPreview(side);
      });
      if (sizeSelect) sizeSelect.addEventListener('change', function() {
        state.coverText[side].size = sizeSelect.value;
        updateCoverTextPreview(side);
      });
      if (lhSelect) lhSelect.addEventListener('change', function() {
        state.coverText[side].lineHeight = lhSelect.value;
        updateCoverTextPreview(side);
      });
      if (widthRange) widthRange.addEventListener('input', function() {
        var w = parseInt(widthRange.value, 10) || 50;
        state.coverText[side].w = w;
        if (widthVal) widthVal.textContent = w + '%';
        updateCoverTextPreview(side);
      });
    });

    initDraggableOverlays();
  }

  /* ==========================================================================
     COLOR PICKERS — Pickr spectrum (Constructor 4)
     ========================================================================== */
  var pickrInstances = {};

  var _flashTimers = {};

  function flashPickrButton(btn, label) {
    if (!btn) return;
    var btnId = btn.getAttribute('data-flash-id');
    if (!btnId) {
      btnId = 'flash_' + Math.random().toString(36).substr(2, 6);
      btn.setAttribute('data-flash-id', btnId);
    }
    if (_flashTimers[btnId]) clearTimeout(_flashTimers[btnId]);
    var orig = btn.classList.contains('pcr-save') ? 'Save' : 'Clear';
    var cls = btn.classList.contains('pcr-save') ? 'pcr-save--done' : 'pcr-clear--done';
    btn.value = label;
    btn.classList.add(cls);
    _flashTimers[btnId] = setTimeout(function() {
      btn.value = orig;
      btn.classList.remove(cls);
      delete _flashTimers[btnId];
    }, 1500);
  }

  function getPickrBtn(pickrInstance, type) {
    if (!pickrInstance || !pickrInstance.getRoot) return null;
    var root = pickrInstance.getRoot();
    if (root.interaction && root.interaction[type]) return root.interaction[type];
    var app = root.app || root.root;
    return app ? app.querySelector('.pcr-' + type) : null;
  }

  function resetPickrSaveBtn(pickrInstance) {
    var btn = getPickrBtn(pickrInstance, 'save');
    if (!btn) return;
    var btnId = btn.getAttribute('data-flash-id');
    if (btnId && _flashTimers[btnId]) {
      clearTimeout(_flashTimers[btnId]);
      delete _flashTimers[btnId];
    }
    btn.value = 'Save';
    btn.classList.remove('pcr-save--done');
  }

  function updateColorIndicator(containerId, hex) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var indicator = container.querySelector('.vinyl-color-indicator');
    if (!indicator) {
      indicator = document.createElement('span');
      indicator.className = 'vinyl-color-indicator';
      indicator.innerHTML = '<span class="vinyl-color-indicator__swatch"></span><span class="vinyl-color-indicator__hex"></span>';
      var label = container.querySelector('.vinyl-field-label');
      if (label) {
        label.appendChild(indicator);
      } else {
        container.insertBefore(indicator, container.firstChild);
      }
    }
    var swatch = indicator.querySelector('.vinyl-color-indicator__swatch');
    var hexLabel = indicator.querySelector('.vinyl-color-indicator__hex');
    if (swatch) swatch.style.backgroundColor = hex;
    if (hexLabel) hexLabel.textContent = hex;
  }

  function initSpectrumPickers() {
    if (typeof Pickr === 'undefined') {
      setTimeout(initSpectrumPickers, 200);
      return;
    }
    root.querySelectorAll('.vinyl-color-picker--spectrum').forEach(function(wrapper) {
      var mountEl = wrapper.querySelector('.vinyl-pickr-mount');
      if (!mountEl || mountEl.dataset.pickrReady) return;
      var fieldGroup = wrapper.closest('.vinyl-text-field-group');
      var fieldKey = fieldGroup ? fieldGroup.dataset.fieldKey : '';
      if (!fieldKey) return;

      var savedColor = (state.coverText[fieldKey] && state.coverText[fieldKey].color) || '#804040';

      var pickr = Pickr.create({
        el: mountEl,
        theme: 'nano',
        useAsButton: true,
        inline: true,
        showAlways: true,
        default: savedColor,
        defaultRepresentation: 'HEXA',
        position: 'bottom-start',
        components: {
          preview: true,
          opacity: false,
          hue: true,
          interaction: {
            hex: true,
            input: true,
            save: true,
            clear: true,
            cancel: false
          }
        }
      });

      var _clearingText = false;

      pickr.on('change', function(color) {
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        if (state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = hex;
          updateCoverTextPreview(fieldKey);
        }
        resetPickrSaveBtn(pickr);
        pickr.applyColor(false);
      });

      pickr.on('swatchselect', function(color) {
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        if (state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = hex;
          updateCoverTextPreview(fieldKey);
        }
      });

      pickr.on('save', function(color) {
        if (_clearingText) return;
        if (!color) return;
        var hex = color.toHEXA().toString().substring(0, 7);
        if (state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = hex;
          updateCoverTextPreview(fieldKey);
          saveState();
        }
        flashPickrButton(getPickrBtn(pickr, 'save'), 'Saved!');
        var colorBlock = wrapper.closest('.vinyl-sticker-color-block');
        if (colorBlock) updateColorIndicator(colorBlock.id || (colorBlock.id = 'colorBlock_' + fieldKey), hex);
      });

      pickr.on('clear', function() {
        _clearingText = true;
        var resetColor = '#000000';
        if (state.coverText[fieldKey]) {
          state.coverText[fieldKey].color = resetColor;
          updateCoverTextPreview(fieldKey);
          saveState();
        }
        pickr.setColor(resetColor);
        flashPickrButton(getPickrBtn(pickr, 'clear'), 'Cleared!');
        var colorBlock = wrapper.closest('.vinyl-sticker-color-block');
        if (colorBlock) updateColorIndicator(colorBlock.id || (colorBlock.id = 'colorBlock_' + fieldKey), resetColor);
        setTimeout(function() { _clearingText = false; }, 50);
      });

      mountEl.dataset.pickrReady = '1';
      pickrInstances[fieldKey] = pickr;
    });
  }

  function restorePickrColors() {
    COVER_KEYS.forEach(function(k) {
      var d = state.coverText[k];
      if (d && pickrInstances[k]) {
        var c = (!d.text && (d.color === '#FFFFFF' || !d.color)) ? '#804040' : (d.color || '#804040');
        d.color = c;
        pickrInstances[k].setColor(c);
      }
    });
  }

  /* ==========================================================================
     FORMAT TOOLBAR — Bold / Italic / Underline (ported from main)
     ========================================================================== */
  function bindFormatToolbars() {
    root.querySelectorAll('.vinyl-format-toolbar').forEach(function(toolbar) {
      var target = toolbar.dataset.formatTarget || '';
      toolbar.querySelectorAll('.vinyl-format-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var format = btn.dataset.format;
          btn.classList.toggle('vinyl-format-btn--active');
          var isActive = btn.classList.contains('vinyl-format-btn--active');
          var fieldGroup = btn.closest('.vinyl-text-field-group');
          if (fieldGroup) {
            var key = fieldGroup.dataset.fieldKey;
            if (key && state.coverText[key]) {
              state.coverText[key][format] = isActive;
              if (format === 'bold' || format === 'italic') preloadFont(state.coverText[key].font, state.coverText[key].bold, state.coverText[key].italic);
              updateCoverTextPreview(key);
              return;
            }
          }
          if (target.startsWith('cover')) {
            var side = target.replace('cover', '');
            if (state.coverText[side]) {
              state.coverText[side][format] = isActive;
              if (format === 'bold' || format === 'italic') preloadFont(state.coverText[side].font, state.coverText[side].bold, state.coverText[side].italic);
              updateCoverTextPreview(side);
            }
          }
        });
      });
    });
  }

  /* ==========================================================================
     ADD-ONS, QUANTITY, ACCORDION
     ========================================================================== */
  function bindAddons() {
    qAll('.vinyl-addon input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        updateAddonsTotal();
        updateStepCheckmarks();
        var shippingEl = root.querySelector('.shipping_days');
        if (shippingEl) {
          var priorityCb = root.querySelector('.vinyl-addon input[data-value="15"]:checked');
          shippingEl.textContent = priorityCb ? '3-5 days' : (config.processingDays || '7-10 days');
        }
        saveState();
      });
    });
  }

  function bindQuantity() {
    if (!dom.quantityInput) return;
    var controls = dom.quantityInput.closest('.vinyl-quantity__controls');
    var minus = controls && controls.querySelector('[name="minus"]');
    var plus  = controls && controls.querySelector('[name="plus"]');
    if (minus) minus.addEventListener('click', function() {
      var v = parseInt(dom.quantityInput.value, 10) || 1;
      if (v > 1) { dom.quantityInput.value = v - 1; state.quantity = v - 1; updatePriceDisplay(); saveState(); }
    });
    if (plus) plus.addEventListener('click', function() {
      var v = parseInt(dom.quantityInput.value, 10) || 1;
      dom.quantityInput.value = v + 1; state.quantity = v + 1; updatePriceDisplay(); saveState();
    });
    dom.quantityInput.addEventListener('change', function() {
      var val = parseInt(dom.quantityInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      dom.quantityInput.value = val; state.quantity = val; updatePriceDisplay(); saveState();
    });
  }

  function bindAccordion() {
    var steps = dom.accordion ? dom.accordion.querySelectorAll('.vinyl-step') : [];
    steps.forEach(function(step) {
      var header = step.querySelector('.vinyl-step__header');
      if (!header) return;
      header.addEventListener('click', function() {
        var isActive = step.classList.contains('vinyl-step--active');
        var anchorY = step.getBoundingClientRect().top;

        steps.forEach(function(s) { s.classList.remove('vinyl-step--active'); });
        if (!isActive) step.classList.add('vinyl-step--active');

        var t0 = performance.now();
        (function pin() {
          var cur = step.getBoundingClientRect().top;
          var diff = cur - anchorY;
          if (Math.abs(diff) > 1) window.scrollBy(0, diff);
          if (performance.now() - t0 < 450) requestAnimationFrame(pin);
        })();
      });
    });
    if (steps.length && !steps[0].classList.contains('vinyl-step--active')) steps[0].classList.add('vinyl-step--active');
  }

  /* ==========================================================================
     TEXT-ON-IMAGE COMPOSITING (ported from Main Constructor 2)
     ========================================================================== */

  var MAX_CANVAS_SIZE = 3600;
  var COVER_MARGIN_PCT = 0.08;
  var FONT_SCALE_REF = 600;
  var _fontCache = {};
  var _imageCache = {};

  function loadImageForCanvas(src) {
    return new Promise(function(resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() { resolve(img); };
      img.onerror = function() {
        var img2 = new Image();
        img2.onload = function() { resolve(img2); };
        img2.onerror = reject;
        img2.src = src;
      };
      img.src = src;
    });
  }

  function getImageSrcFromUpload(upload) {
    if (upload.previewUrl) return upload.previewUrl;
    if (upload.fileUrl) return upload.fileUrl;
    if (upload.blob) return URL.createObjectURL(upload.blob);
    return null;
  }

  function precacheImageForCanvas(index) {
    var upload = state.uploadedFiles[index];
    if (!upload) return;
    var src = getImageSrcFromUpload(upload);
    if (!src || (_imageCache[index] && _imageCache[index].src === src)) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = src;
    _imageCache[index] = { src: src, ready: new Promise(function(resolve) {
      img.onload = function() { resolve(img); };
      img.onerror = function() {
        var img2 = new Image();
        img2.src = src;
        img2.onload = function() { resolve(img2); };
        img2.onerror = function() { resolve(null); };
      };
    })};
  }

  function getCachedImage(index) {
    var upload = state.uploadedFiles[index];
    if (!upload) return Promise.resolve(null);
    var src = getImageSrcFromUpload(upload);
    if (_imageCache[index] && _imageCache[index].src === src) return _imageCache[index].ready;
    precacheImageForCanvas(index);
    return _imageCache[index] ? _imageCache[index].ready : loadImageForCanvas(src);
  }

  function injectFontCSS(fontFamily, weight, ital) {
    var id = 'gf-' + fontFamily.replace(/\s+/g, '-') + '-' + weight + '-' + ital;
    if (document.getElementById(id)) return;
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=' +
      encodeURIComponent(fontFamily) + ':ital,wght@' + ital + ',' + weight + '&display=swap';
    document.head.appendChild(link);
  }

  function loadFontForCanvas(fontFamily, bold, italic) {
    var w = bold ? 700 : 400;
    var it = italic ? 1 : 0;
    var key = fontFamily + '|' + w + '|' + it;
    if (_fontCache[key]) return _fontCache[key];

    injectFontCSS(fontFamily, 400, 0);
    if (w !== 400) injectFontCSS(fontFamily, w, 0);
    if (it !== 0)  injectFontCSS(fontFamily, 400, it);
    if (w !== 400 && it !== 0) injectFontCSS(fontFamily, w, it);

    var spec = (italic ? 'italic ' : '') + (bold ? 'bold ' : '') + '20px "' + fontFamily + '"';

    _fontCache[key] = new Promise(function(resolve) {
      var done = false;
      var finish = function(label) {
        if (done) return;
        done = true;
        resolve();
      };
      setTimeout(function() { finish('timeout'); }, 800);
      document.fonts.load(spec).then(function() {
        finish('loaded');
      }).catch(function() {
        finish('fallback');
      });
    });

    return _fontCache[key];
  }

  function buildCanvasFont(data, fontSize) {
    var s = '';
    if (data.italic) s += 'italic ';
    if (data.bold)   s += 'bold ';
    s += Math.round(fontSize) + 'px "' + (data.font || data.fontFamily || 'sans-serif') + '", sans-serif';
    return s;
  }

  function wrapText(ctx, text, maxW) {
    if (!text) return [''];
    var words = text.split(' ');
    var lines = [];
    var cur = '';
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      if (ctx.measureText(word).width > maxW && word.length > 1) {
        if (cur) { lines.push(cur); cur = ''; }
        var partial = '';
        for (var c = 0; c < word.length; c++) {
          var test = partial + word[c];
          if (ctx.measureText(test).width > maxW && partial) {
            lines.push(partial);
            partial = word[c];
          } else {
            partial = test;
          }
        }
        cur = partial;
      } else {
        var testLine = cur ? (cur + ' ' + word) : word;
        if (ctx.measureText(testLine).width > maxW && cur) {
          lines.push(cur);
          cur = word;
        } else {
          cur = testLine;
        }
      }
    }
    if (cur) lines.push(cur);
    return lines.length ? lines : [''];
  }

  function measureWidest(ctx, lines) {
    var max = 0;
    for (var i = 0; i < lines.length; i++) {
      var w = ctx.measureText(lines[i]).width;
      if (w > max) max = w;
    }
    return max;
  }

  function fitTextToWidth(ctx, textData, inputLines, maxW, initialSize, minSize) {
    var fs = initialSize;
    var lines, widest;
    for (var attempt = 0; attempt < 30; attempt++) {
      ctx.font = buildCanvasFont(textData, fs);
      lines = [];
      for (var i = 0; i < inputLines.length; i++) {
        var wrapped = wrapText(ctx, inputLines[i], maxW);
        for (var j = 0; j < wrapped.length; j++) lines.push(wrapped[j]);
      }
      widest = measureWidest(ctx, lines);
      if (widest <= maxW || fs <= minSize) break;
      var ratio = maxW / widest * 0.93;
      var newFs = Math.floor(fs * ratio);
      if (newFs >= fs) newFs = fs - 1;
      fs = Math.max(minSize, newFs);
    }
    return { lines: lines, fontSize: fs, widest: widest, attempts: attempt };
  }

  function getCoverPosition(placement, canvasW, canvasH, totalTextH, fontSize, pad) {
    var mx = pad || Math.round(canvasW * COVER_MARGIN_PCT);
    var my = mx;
    var result = { x: canvasW / 2, baselineY: canvasH / 2, align: 'center' };
    switch (placement) {
      case 'top-left':     result = { x: mx,             baselineY: my + fontSize,                      align: 'left' };   break;
      case 'top':          result = { x: canvasW / 2,    baselineY: my + fontSize,                      align: 'center' }; break;
      case 'top-right':    result = { x: canvasW - mx,   baselineY: my + fontSize,                      align: 'right' };  break;
      case 'left':         result = { x: mx,             baselineY: (canvasH - totalTextH) / 2 + fontSize, align: 'left' };   break;
      case 'center':       result = { x: canvasW / 2,    baselineY: (canvasH - totalTextH) / 2 + fontSize, align: 'center' }; break;
      case 'right':        result = { x: canvasW - mx,   baselineY: (canvasH - totalTextH) / 2 + fontSize, align: 'right' };  break;
      case 'bottom-left':  result = { x: mx,             baselineY: canvasH - my - totalTextH + fontSize,  align: 'left' };   break;
      case 'bottom':       result = { x: canvasW / 2,    baselineY: canvasH - my - totalTextH + fontSize,  align: 'center' }; break;
      case 'bottom-right': result = { x: canvasW - mx,   baselineY: canvasH - my - totalTextH + fontSize,  align: 'right' };  break;
    }
    return result;
  }

  function drawCoverText(ctx, lines, fontSize, textData, canvasW, canvasH, pad) {
    var lineHeight = parseFloat(textData.lineHeight) || 1.2;
    var lhPx = Math.round(fontSize * lineHeight);
    var totalH = lines.length * lhPx;
    var effectivePad = pad || Math.round(canvasW * COVER_MARGIN_PCT);
    var maxW = canvasW - effectivePad * 2;
    var hardLimit = maxW + Math.round(effectivePad * 0.3);
    var pos = getCoverPosition(textData.position, canvasW, canvasH, totalH, fontSize, effectivePad);
    ctx.font = buildCanvasFont(textData, fontSize);
    ctx.fillStyle = textData.color || '#FFFFFF';
    ctx.textAlign = pos.align;
    ctx.textBaseline = 'alphabetic';
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    for (var i = 0; i < lines.length; i++) {
      var y = pos.baselineY + i * lhPx;
      ctx.fillText(lines[i], pos.x, y, hardLimit);
    }
    if (textData.underline) {
      ctx.strokeStyle = textData.color || '#FFFFFF';
      ctx.lineWidth = Math.max(2, Math.round(fontSize * 0.06));
      for (var i = 0; i < lines.length; i++) {
        var y = pos.baselineY + i * lhPx;
        var uy = y + Math.round(fontSize * 0.1);
        var lw = Math.min(ctx.measureText(lines[i]).width, hardLimit);
        var lx = pos.x;
        if (pos.align === 'center') lx -= lw / 2;
        else if (pos.align === 'right') lx -= lw;
        ctx.beginPath();
        ctx.moveTo(lx, uy);
        ctx.lineTo(lx + lw, uy);
        ctx.stroke();
      }
    }
  }

  function ensureSlideVisible(slideDataAttr) {
    var slide = root.querySelector('[data-slide="' + slideDataAttr + '"]');
    if (!slide) return { slide: null, restore: function() {} };
    var computed = window.getComputedStyle(slide);
    var wasHidden = (computed.display === 'none' || slide.offsetWidth === 0);
    var origStyle = slide.getAttribute('style') || '';
    if (wasHidden) {
      slide.setAttribute('style', origStyle +
        ';display:block !important;position:fixed !important;' +
        'top:-9999px !important;left:0 !important;' +
        'width:500px !important;height:500px !important;' +
        'visibility:visible !important;z-index:-1 !important;' +
        'pointer-events:none !important;');
      slide.offsetHeight;
    }
    return {
      slide: slide,
      restore: function() {
        if (wasHidden) slide.setAttribute('style', origStyle);
      }
    };
  }

  function captureOverlayWithHtml2Canvas(overlay, targetW, targetH) {
    if (typeof html2canvas === 'undefined') {
      console.warn('[Compositor] html2canvas not loaded, using Canvas fallback');
      return Promise.resolve(null);
    }
    var elW = overlay.offsetWidth;
    var elH = overlay.offsetHeight;
    if (elW < 10 || elH < 10) {
      return Promise.resolve(null);
    }
    var captureScale = Math.max(targetW / elW, targetH / elH);
    captureScale = Math.min(captureScale, 6);
    return html2canvas(overlay, {
      backgroundColor: null,
      scale: captureScale,
      logging: false,
      useCORS: true,
      allowTaint: true
    }).then(function(capturedCanvas) {
      return capturedCanvas;
    }).catch(function(err) {
      console.error('[html2canvas] Capture failed:', err);
      return null;
    });
  }

  function canvasFallbackComposite(baseImg, w, h, td, side, outMime) {
    var canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(baseImg, 0, 0, w, h);
    var cScale = w / FONT_SCALE_REF;
    var initSize = Math.round((parseInt(td.size, 10) || 24) * cScale);
    var minSize = Math.max(8, Math.round(10 * cScale));
    var maxW = w - Math.round(w * COVER_MARGIN_PCT) * 2;
    var inputLines = td.text.split('\n');
    var fit = fitTextToWidth(ctx, td, inputLines, maxW, initSize, minSize);
    drawCoverText(ctx, fit.lines, fit.fontSize, td, w, h);
    var mime = (outMime === 'image/png' || outMime === 'image/webp') ? outMime : 'image/jpeg';
    var quality = mime === 'image/png' ? undefined : 0.97;
    return new Promise(function(resolve) {
      canvas.toBlob(function(blob) {
        if (!blob) {
          var dataUrl = canvas.toDataURL(mime, quality);
          fetch(dataUrl).then(function(r) { return r.blob(); }).then(resolve)
            .catch(function() { resolve(null); });
        } else { resolve(blob); }
      }, mime, quality);
    });
  }

  function compositeCoverImage(side) {
    var idx = side === 'A' ? 1 : 2;
    var upload = state.uploadedFiles[idx];
    var keys = side === 'A' ? FRONT_KEYS : BACK_KEYS;
    var hasAnyText = keys.some(function(k) { return state.coverText[k] && state.coverText[k].text; });
    if (!upload || !hasAnyText) return Promise.resolve(null);
    if (upload.isPassthrough) {
      console.log('[Vinyl V4 Cover ' + side + '] passthrough (PDF/TIFF) — skipping text composite, sending original file');
      return Promise.resolve(null);
    }

    var sourceMime = upload.mime || 'image/jpeg';
    var outMime = (sourceMime === 'image/png' || sourceMime === 'image/webp') ? sourceMime : 'image/jpeg';
    var quality = outMime === 'image/png' ? undefined : 0.97;

    return getCachedImage(idx).then(function(baseImg) {
      if (!baseImg) return null;
      var t0 = performance.now();
      var ow = baseImg.naturalWidth, oh = baseImg.naturalHeight;
      var sc = 1;
      if (Math.max(ow, oh) > MAX_CANVAS_SIZE) sc = MAX_CANVAS_SIZE / Math.max(ow, oh);
      var w = Math.round(ow * sc), h = Math.round(oh * sc);

      var finalCanvas = document.createElement('canvas');
      finalCanvas.width = w;
      finalCanvas.height = h;
      var ctx = finalCanvas.getContext('2d');
      ctx.drawImage(baseImg, 0, 0, w, h);

      keys.forEach(function(key) {
        var td = state.coverText[key];
        if (!td || !td.text) return;

        var cScale = w / FONT_SCALE_REF;
        var initSize = Math.round((parseInt(td.size, 10) || 24) * cScale);
        var minSize = Math.max(8, Math.round(10 * cScale));
        var maxW = w - Math.round(w * COVER_MARGIN_PCT) * 2;
        var inputLines = td.text.split('\n');
        var fit = fitTextToWidth(ctx, td, inputLines, maxW, initSize, minSize);
        drawCoverText(ctx, fit.lines, fit.fontSize, td, w, h);
      });

      console.log('[Vinyl Cover ' + side + ' COMPOSITE]',
        ow + 'x' + oh, '→', w + 'x' + h, '(' + outMime + ')',
        '| time:', Math.round(performance.now() - t0), 'ms');

      return new Promise(function(resolve) {
        finalCanvas.toBlob(function(blob) {
          if (!blob) {
            var dataUrl = finalCanvas.toDataURL(outMime, quality);
            fetch(dataUrl).then(function(r) { return r.blob(); })
              .then(resolve).catch(function() { resolve(null); });
          } else { resolve(blob); }
        }, outMime, quality);
      });
    }).catch(function(err) {
      console.error('[Vinyl Cover ' + side + '] FATAL:', err);
      return null;
    });
  }

  function generateCompositedImages() {
    var results = {};
    var fontLoads = [];
    COVER_KEYS.forEach(function(key) {
      var ct = state.coverText[key];
      if (ct && ct.text) fontLoads.push(loadFontForCanvas(ct.font, ct.bold, ct.italic));
    });
    var t0 = performance.now();
    function fileFromBlob(blob, baseName) {
      var ext = extFromMime(blob.type);
      return new File([blob], baseName + '.' + ext, { type: blob.type || 'image/jpeg' });
    }
    return Promise.all(fontLoads).then(function() {
      return Promise.all([
        compositeCoverImage('A').then(function(b) {
          if (b) results.coverA = fileFromBlob(b, 'front_cover_with_text');
        }),
        compositeCoverImage('B').then(function(b) {
          if (b) results.coverB = fileFromBlob(b, 'back_cover_with_text');
        })
      ]).then(function() {
        console.log('[Vinyl 3step] Compositing complete in', Math.round(performance.now() - t0), 'ms —',
          'coverA:', results.coverA ? (results.coverA.size + 'b ' + results.coverA.type) : 'skip',
          'coverB:', results.coverB ? (results.coverB.size + 'b ' + results.coverB.type) : 'skip');
        return results;
      });
    });
  }

  /* ==========================================================================
     CDN HELPERS
     ========================================================================== */
  var _cdnUploadQueue = Promise.resolve();

  function uploadBlobToShopifyCdn(blob, filename) {
    return new Promise(function(resolve) {
      _cdnUploadQueue = _cdnUploadQueue.then(function() {
        return new Promise(function(done) {
          var variantInput = dom.form ? dom.form.querySelector('[name="id"]') : null;
          var variantId = variantInput ? variantInput.value : (config.variantId || '');
          if (!variantId) { console.warn('[Vinyl V4] No variant for CDN upload'); resolve(blob); done(); return; }

          var propKey = '_img_' + Date.now() + '_' + Math.random().toString(36).substring(2, 6);
          var frameName = 'vinyl_img_frame_' + Date.now();

          var iframe = document.createElement('iframe');
          iframe.name = frameName;
          iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
          document.body.appendChild(iframe);

          var form = document.createElement('form');
          form.method = 'POST';
          form.action = '/cart/add';
          form.enctype = 'multipart/form-data';
          form.target = frameName;
          form.style.display = 'none';

          var inp = function(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); };
          inp('id', variantId);
          inp('quantity', '1');

          var fileInput = document.createElement('input');
          fileInput.type = 'file';
          fileInput.name = 'properties[' + propKey + ']';
          fileInput.style.display = 'none';
          var fallbackName = filename || ('image.' + extFromMime(blob && blob.type));
          try {
            var file = (blob instanceof File) ? blob : new File([blob], fallbackName, { type: blob.type || 'image/jpeg' });
            var dt = new DataTransfer();
            dt.items.add(file);
            fileInput.files = dt.files;
          } catch (e) {
            console.warn('[Vinyl V4] DataTransfer not supported');
            resolve(blob); done(); return;
          }
          form.appendChild(fileInput);
          document.body.appendChild(form);

          console.log('[Vinyl V4] Uploading image to Shopify CDN:', filename || 'image.jpg', '(' + ((blob.size || 0) / 1024).toFixed(0) + 'KB)');

          var attempts = 0;
          var maxAttempts = 40;

          function poll() {
            attempts++;
            fetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                var cdnUrl = '';
                var itemKey = '';
                for (var i = 0; i < cart.items.length; i++) {
                  var p = cart.items[i].properties;
                  if (p && p[propKey] !== undefined) {
                    itemKey = cart.items[i].key;
                    var val = typeof p[propKey] === 'string' ? p[propKey] : '';
                    if (val.indexOf('cdn.shopify.com') !== -1) { cdnUrl = val; }
                    break;
                  }
                }
                if (!cdnUrl && attempts < maxAttempts) {
                  setTimeout(poll, 500);
                  return;
                }
                console.log('[Vinyl V4] CDN result:', cdnUrl ? cdnUrl.substring(0, 80) : 'FAILED');
                var cleanup = itemKey
                  ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: itemKey, quantity: 0 }) }).catch(function() {})
                  : Promise.resolve();
                cleanup.then(function() {
                  try { form.remove(); iframe.remove(); } catch(e) {}
                  resolve(cdnUrl || blob);
                  done();
                });
              })
              .catch(function() {
                if (attempts < maxAttempts) { setTimeout(poll, 500); }
                else { try { form.remove(); iframe.remove(); } catch(e) {} resolve(blob); done(); }
              });
          }

          form.submit();
          setTimeout(poll, 2000);
        });
      });
    });
  }

  /* ==========================================================================
     FILESTACK BLOB UPLOAD (preserves JPEG format in orders)
     ========================================================================== */
  function uploadBlobToFilestack(blob, filename) {
    if (!FILESTACK_API_KEY) {
      return uploadBlobToShopifyCdn(blob, filename);
    }
    var name = filename || ('image.' + extFromMime(blob && blob.type));
    var fd = new FormData();
    fd.append('fileUpload', blob, name);
    fd.append('filename', name);
    if (blob && blob.type) fd.append('mimetype', blob.type);
    return fetch('https://www.filestackapi.com/api/store/S3?key=' + FILESTACK_API_KEY, {
      method: 'POST',
      body: fd
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Filestack HTTP ' + res.status);
      return res.text();
    })
    .then(function(text) {
      try {
        var data = JSON.parse(text);
        if (data.url) {
          // Append ?dl=true so admin clicks in the Shopify order trigger a
          // download (Content-Disposition: attachment) instead of opening
          // the image inline. Filename + extension still come from the
          // `filename` multipart field sent above.
          var publicUrl = data.url + '?dl=true';
          console.log('[Vinyl V4] Composited image uploaded to Filestack:', publicUrl);
          return publicUrl;
        }
        throw new Error('No URL in response');
      } catch (e) {
        if (text.indexOf('blocked') !== -1 || text.indexOf('error') !== -1) {
          throw new Error('Filestack blocked: ' + text.substring(0, 100));
        }
        throw e;
      }
    })
    .catch(function(err) {
      console.warn('[Vinyl V4] Filestack upload failed, falling back to Shopify CDN:', err.message || err);
      return uploadBlobToShopifyCdn(blob, filename);
    });
  }

  /* ==========================================================================
     FORM SUBMISSION
     ========================================================================== */
  function buildFormData(composited) {
    var fd = new FormData();
    var variantInput = dom.form.querySelector('[name="id"]');
    var variantId = variantInput ? variantInput.value : (config.variantId || '');
    var qty = dom.quantityInput ? parseInt(dom.quantityInput.value, 10) || 1 : 1;
    if (!variantId) throw new Error('No product variant found');
    fd.append('id', variantId);
    fd.append('quantity', qty);

    composited = composited || {};
    var compositedMap = {
      1: composited.coverA || null,
      2: composited.coverB || null
    };
    var imageLabels = { 1: 'Front Cover', 2: 'Back Cover' };
    for (var idx = 1; idx <= 2; idx++) {
      var upload = state.uploadedFiles[idx];
      if (!upload) continue;
      var label = imageLabels[idx];
      var comp = compositedMap[idx];
      var uploadExt = extFromMime(upload.mime);
      if (comp && typeof comp === 'string' && comp.indexOf('://') !== -1) {
        fd.append('properties[' + label + ']', comp);
      } else if (comp && comp instanceof Blob) {
        fd.append('properties[' + label + ']', comp, comp.name || ('composited_' + idx + '.' + extFromMime(comp.type)));
      } else if (upload.fileUrl && upload.fileUrl.indexOf('://') !== -1 && upload.fileUrl.indexOf('data:') !== 0) {
        fd.append('properties[' + label + ']', upload.fileUrl);
      } else if (upload.blob) {
        fd.append('properties[' + label + ']', upload.blob, upload.name || ('image_' + idx + '.' + uploadExt));
      } else if (upload.previewUrl && upload.previewUrl.indexOf('data:') === 0) {
        fd.append('properties[' + label + ']', upload.previewUrl);
      } else {
        fd.append('properties[' + label + ']', 'Uploaded: ' + (upload.name || 'image'));
      }
    }

    var coverLabels = { A: 'Front Cover Text 1', A2: 'Front Cover Text 2', A3: 'Front Cover Text 3', B: 'Back Cover Text 1', B2: 'Back Cover Text 2', B3: 'Back Cover Text 3', B4: 'Back Cover Text 4' };
    var coverColorLabels = { A: 'Front Cover Text 1 Color', A2: 'Front Cover Text 2 Color', A3: 'Front Cover Text 3 Color', B: 'Back Cover Text 1 Color', B2: 'Back Cover Text 2 Color', B3: 'Back Cover Text 3 Color', B4: 'Back Cover Text 4 Color' };
    var coverFontLabels = { A: 'Front Cover Text 1 Font', A2: 'Front Cover Text 2 Font', A3: 'Front Cover Text 3 Font', B: 'Back Cover Text 1 Font', B2: 'Back Cover Text 2 Font', B3: 'Back Cover Text 3 Font', B4: 'Back Cover Text 4 Font' };
    COVER_KEYS.forEach(function(key) {
      var ct = state.coverText[key];
      var domInput = sid('coverText' + key);
      if (domInput && domInput.value && domInput.value.trim()) ct.text = domInput.value.trim();
      if (ct && ct.text) {
        fd.append('properties[' + coverLabels[key] + ']', ct.text);
        if (ct.color) fd.append('properties[' + coverColorLabels[key] + ']', ct.color);
        if (ct.font) fd.append('properties[' + coverFontLabels[key] + ']', ct.font);
      }
    });

    var addonDetails = [];
    qAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) {
      var lbl = cb.closest('.vinyl-addon') && cb.closest('.vinyl-addon').querySelector('label');
      var priceVal = cb.dataset.value || '0';
      addonDetails.push({ name: lbl ? lbl.textContent.trim() : 'Add-on', price: priceVal });
    });
    if (addonDetails.length) {
      fd.append('properties[Add-on Services]', addonDetails.map(function(a) { return a.name + ' (+$' + a.price + ')'; }).join(' | '));
      addonDetails.forEach(function(a, i) { fd.append('properties[Service ' + (i + 1) + ']', a.name + ' — $' + a.price); });
    }
    return fd;
  }

  function buildAddonItems() {
    var qty = dom.quantityInput ? parseInt(dom.quantityInput.value, 10) || 1 : 1;
    var items = [];
    qAll('.vinyl-addon input[type="checkbox"]:checked').forEach(function(cb) {
      var vid = cb.dataset.variantId || cb.dataset.variant_id;
      if (vid) items.push({ id: parseInt(vid, 10), quantity: qty, properties: { _hidden: 'true' } });
    });
    return items;
  }

  function bindFormSubmit() {
    if (!dom.form) return;
    dom.form.addEventListener('submit', function(ev) {
      ev.preventDefault();
      if (!state.customizationComplete) return;
      var submitButton = dom.form.querySelector('[type="submit"]');
      if (!submitButton) return;
      submitButton.disabled = true;
      submitButton.classList.add('loading');
      var spinner = submitButton.querySelector('.vinyl-spinner');
      if (spinner) spinner.classList.remove('hidden');

      var hasTextOverlays = COVER_KEYS.some(function(k) {
        return state.coverText[k] && state.coverText[k].text;
      });

      var compositingPromise = hasTextOverlays
        ? generateCompositedImages()
        : Promise.resolve({});

      compositingPromise.then(function(composited) {
        var uploadTasks = [];
        ['coverA', 'coverB'].forEach(function(key) {
          if (composited[key] && composited[key] instanceof Blob) {
            uploadTasks.push(
              uploadBlobToFilestack(composited[key], composited[key].name || (key + '.jpg'))
                .then(function(url) {
                  if (typeof url === 'string' && url.indexOf('://') !== -1) {
                    console.log('[Vinyl V4] ' + key + ' → CDN:', url.substring(0, 80));
                    composited[key] = url;
                  }
                })
            );
          }
        });
        return Promise.all(uploadTasks).then(function() { return composited; });
      }).then(function(composited) {
        var fd = buildFormData(composited);
        var addonItems = buildAddonItems();
        return fetch('/cart/add', { method: 'POST', body: fd })
        .then(function(res) {
          if (!res.ok && res.status >= 400 && res.status < 500) return res.text().then(function() { throw new Error('Could not add to cart'); });
          return res.text();
        })
        .then(function() {
          if (!addonItems.length) return Promise.resolve();
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: addonItems }) })
            .then(function(res) {
              if (!res.ok) console.warn('[Vinyl] Addon add failed, status:', res.status);
              return res.json();
            })
            .catch(function(e) { console.warn('[Vinyl] Addon error (non-blocking):', e); });
        })
        .then(function() {
          try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {}
          window.location.href = '/cart';
        })
        .catch(function(err) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          alert(err.message || 'Could not add to cart.');
        });
      }).catch(function(err) {
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        console.error('[Vinyl] Compositing error:', err);
        alert('Error preparing images. Please try again.');
      });
    });
  }

  /* ==========================================================================
     MODALS (walkthrough etc.)
     ========================================================================== */
  function bindModals() {
    qAll('.vinyl-product__help-trigger').forEach(function(tr) {
      tr.addEventListener('click', function() {
        var mid = tr.dataset.modal;
        if (mid) { var m = document.getElementById(mid); if (m) m.style.display = 'flex'; }
      });
    });
    qAll('.vinyl-modal__close').forEach(function(close) {
      close.addEventListener('click', function() { var m = close.closest('.vinyl-modal'); if (m) m.style.display = 'none'; });
    });
  }

  /* ==========================================================================
     Remove Zakeke app injection (hides our ATC, shows "Out of Stock")
     ========================================================================== */
  function removeZakeke() {
    var zBtn = root.querySelector('#zakeke-product-button');
    if (zBtn) {
      var container = zBtn.closest('.zakeke-product-button-container') || zBtn.parentNode;
      if (container) container.remove(); else zBtn.remove();
    }
    root.querySelectorAll('.zakeke-product-button-container').forEach(function(el) { el.remove(); });
    root.querySelectorAll('[name="zakeke-product-id"], [name="zakeke-locale"]').forEach(function(el) { el.remove(); });
    var atcBtn = root.querySelector('.vinyl-btn--atc');
    if (atcBtn) atcBtn.style.removeProperty('display');
  }

  /* ==========================================================================
     INIT
     ========================================================================== */
  function init() {
    if (!dom.accordion) return;
    removeZakeke();
    setTimeout(removeZakeke, 100);
    setTimeout(removeZakeke, 500);
    setTimeout(removeZakeke, 1500);
    setTimeout(removeZakeke, 3000);
    var cartActions = root.querySelector('.vinyl-cart-actions');
    if (cartActions && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function() { removeZakeke(); })
        .observe(cartActions, { childList: true, subtree: true });
    }
    bindPreviewThumbs();
    bindAccordion();
    bindUploaders();
    bindCropModal();
    bindCoverTextUI();
    initSpectrumPickers();
    bindFormatToolbars();
    applyFontPreviews();
    bindAddons();
    bindQuantity();
    bindFormSubmit();
    bindModals();
    restoreState();
    setTimeout(restorePickrColors, 500);
    checkCustomizationStatus();
    updatePriceDisplay();

    document.addEventListener('currency:update', function() {
      if (window._vinylCurrencyUpdating) return;
      updatePriceDisplay();
    });
  }

  function initCustomFontSizeDropdowns() {
    var selects = document.querySelectorAll('.vinyl-fontsize-select');
    selects.forEach(function(sel) {
      if (sel.closest('.vinyl-custom-select')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'vinyl-custom-select';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'vinyl-custom-select__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      var selectedOpt = sel.options[sel.selectedIndex];
      trigger.textContent = selectedOpt ? selectedOpt.text : '';

      var dropdown = document.createElement('div');
      dropdown.className = 'vinyl-custom-select__dropdown';
      dropdown.setAttribute('role', 'listbox');

      Array.from(sel.options).forEach(function(opt) {
        var item = document.createElement('div');
        item.className = 'vinyl-custom-select__option';
        if (opt.selected) item.classList.add('vinyl-custom-select__option--selected');
        item.setAttribute('role', 'option');
        item.setAttribute('data-value', opt.value);
        item.textContent = opt.text;

        item.addEventListener('click', function(e) {
          e.stopPropagation();
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          trigger.textContent = opt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.remove('vinyl-custom-select__option--selected');
          });
          item.classList.add('vinyl-custom-select__option--selected');
          wrapper.classList.remove('vinyl-custom-select--open');
          trigger.setAttribute('aria-expanded', 'false');
        });

        dropdown.appendChild(item);
      });

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = wrapper.classList.contains('vinyl-custom-select--open');

        document.querySelectorAll('.vinyl-custom-select--open').forEach(function(w) {
          w.classList.remove('vinyl-custom-select--open');
          w.querySelector('.vinyl-custom-select__trigger').setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          wrapper.classList.add('vinyl-custom-select--open');
          trigger.setAttribute('aria-expanded', 'true');
          var selectedItem = dropdown.querySelector('.vinyl-custom-select__option--selected');
          if (selectedItem) {
            selectedItem.scrollIntoView({ block: 'nearest' });
          }
        }
      });

      sel.parentNode.insertBefore(wrapper, sel);
      wrapper.appendChild(sel);
      wrapper.appendChild(trigger);
      wrapper.appendChild(dropdown);

      var observer = new MutationObserver(function() {
        var curOpt = sel.options[sel.selectedIndex];
        if (curOpt) {
          trigger.textContent = curOpt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.toggle('vinyl-custom-select__option--selected',
              o.getAttribute('data-value') === sel.value);
          });
        }
      });
      observer.observe(sel, { attributes: true, childList: true, subtree: true });

      sel.addEventListener('change', function() {
        var curOpt = sel.options[sel.selectedIndex];
        if (curOpt) {
          trigger.textContent = curOpt.text;
          dropdown.querySelectorAll('.vinyl-custom-select__option').forEach(function(o) {
            o.classList.toggle('vinyl-custom-select__option--selected',
              o.getAttribute('data-value') === sel.value);
          });
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.vinyl-custom-select')) {
        document.querySelectorAll('.vinyl-custom-select--open').forEach(function(w) {
          w.classList.remove('vinyl-custom-select--open');
          w.querySelector('.vinyl-custom-select__trigger').setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  var _origInit = init;
  init = function() {
    _origInit();
    initCustomFontSizeDropdowns();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
